import { render } from "./PublicPolicies.vue?vue&type=template&id=3fe0c208&scoped=true"
import script from "./PublicPolicies.vue?vue&type=script&lang=js"
export * from "./PublicPolicies.vue?vue&type=script&lang=js"

import "./PublicPolicies.vue?vue&type=style&index=0&id=3fe0c208&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe0c208"]])

export default __exports__